/**
 * Created by mykurisu on 2017/7/7.
 */
const defaults = {
    QrcodeShow: false,
    api: '',
    title: '',
    des: '',

}

export default(state = defaults, action) => {
    switch (action.type) {
        case 'CUSTOMER_QRCODE_INIT':
            return {...state, api: action.payload.api, title: action.payload.title, des: action.payload.des}
        case 'CUSTOMER_QRCODE_SHOW':
            return {...state, QrcodeShow: true}
        case 'CUSTOMER_QRCODE_HIDE':
            return {...state, QrcodeShow: false}
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/customerservice.js